import { usePermissions } from "@/hooks/usePermissions";
import type { PropsWithChildren } from "react";

export const SuperAdminOnly = ({ children }: PropsWithChildren) => {
  const { isSuperAdmin } = usePermissions();

  if (!isSuperAdmin) {
    return null;
  }

  return <>{children}</>;
};
